module.exports = "/fonts/ElevanceSans-Regular.b8596aa969a235a225b9c4b93d969d6b.woff2";